var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"span3"},[_c('Autocomplete',{attrs:{"selected":_vm.selected,"options":_vm.options,"postfix":_vm.postfix,"placeholder":_vm.placeholder,"title":_vm.title},on:{"select":_vm.select,"input":_vm.input,"hide":_vm.hideOptions,"show":_vm.showOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }